import Vue  from 'vue';
import Vuex from 'vuex';

import 'es6-promise/auto';

import store from './store';

import my_investments from './App.vue';

Vue.directive('click-outside', {
	priority: 700,
	bind: function(el, binding, vnode) {
		el.clickOutsideEvent = function(event) {
			// here I check that click was outside the el and his children
			if (!(el == event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				// console.log(binding);
				vnode.context[binding.arg](binding.value);
			}
		};

		// if ((!binding.hasOwnProperty('value')) || binding.value) {
		document.body.addEventListener('click', el.clickOutsideEvent);
		// }
	},
	unbind: function(el) {
		document.body.removeEventListener('click', el.clickOutsideEvent);
	},
});

Vue.use(Vuex);

const app = new Vue({
	render: h => h(my_investments),
	store,
}).$mount('#listFundApplication');